// eslint-disable-next-line no-unused-vars
import React from 'react';
import SidebarLayout from "../../layouts/SidebarLayout/SidebarLayout";
import FiltersSidebar from "../../components/FilterListSidebar/FiltersSidebar.jsx";
import apiClient from "../../utils/api";
import Header from "../../components/Header/Header";
import FullWidthLayout from "../../layouts/FullWidthLayout/FullWidthLayout";


function Databases() {


    const content = <>
        <button onClick={() => {throw new Error("This is your first error!");}}>Raise Test APP Error</button>;
        <button onClick={() => {
            apiClient.getError()
        }}>Raise Test API Error</button>;
    </>

    return <>
        <Header />
        <FullWidthLayout title={"Databases"} mainContent={content}
                       actionButton={undefined} />
    </>
}

export default Databases
